import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=66c2c28e&scoped=true&"
import script from "./Sections.vue?vue&type=script&lang=js&"
export * from "./Sections.vue?vue&type=script&lang=js&"
import style0 from "./Sections.vue?vue&type=style&index=0&id=66c2c28e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2c28e",
  null
  
)

export default component.exports